import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const PageNotFoundPage=()=>{
    const navigate=useNavigate();
    // useEffect(()=>{
    //     navigate("/",{ state: true })
    // },[])
    return(<></>)
}
export default PageNotFoundPage